/**
 * @description: 赛事评选
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="race-manage">
        <div class="race-list" v-show="showList">
            <h1>赛事评选</h1>
            <el-form :inline="true" :model="race_list_form">
                <el-form-item label="门店">
                    <el-select v-model="race_list_form.shop_id" filterable @change="getRaceType(race_list_form.shop_id, '1')">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="赛事类型">
                    <el-select v-model="race_list_form.type" clearable placeholder="请选择赛事类型">
                        <el-option v-for="item in race_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="赛事名称">
                    <el-input placeholder="请输入赛事名称" v-model="race_list_form.name"></el-input>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select v-model="race_list_form.status" clearable placeholder="请选择状态">
                        <el-option label="未开始" value="-1"></el-option>
                        <el-option label="进行中" value="1"></el-option>
                        <el-option label="已结束" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="pull-right">
                    <el-button type="primary" @click="raceAdd">新增赛事</el-button>
                    <el-button type="primary" @click="getRaceTable(1)">查询</el-button>
                </el-form-item>
            </el-form>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="race_table">
                <el-table-column prop="id" label="赛事ID"></el-table-column>
                <el-table-column prop="shop_name" label="门店"></el-table-column>
                <el-table-column prop="type_name" label="赛事类型"></el-table-column>
                <el-table-column prop="name" label="赛事名称"></el-table-column>
                <el-table-column label="赛事时间段">
                    <template slot-scope="scope">
                        {{scope.row.start_time + '~' + scope.row.end_time}}
                    </template>
                </el-table-column>
                <el-table-column prop="status_name" label="状态"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <span class="text-blue" @click="raceModify(scope.row)" v-show="scope.row.status != '2'">修改</span>
                        <span class="text-blue" @click="raceDel(scope.row)">删除</span>
                        <span class="text-blue" @click="raceRank(scope.row)" v-show="scope.row.status != '-1'">排名</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :page-size="GLOBAL.PAGESIZE"
                :current-page.sync="race_page"
                :total="race_total"
                @current-change="getRaceTable">
            </el-pagination>
        </div>
        <!-- 排名 -->
        <div class="race-rank" v-show="showRank">
            <h1>影集赛事排名</h1>
            <el-form :inline="true" :model="race_rank_form">
                <el-form-item label="赛事名称">
                    {{race_rank_form.name}}
                </el-form-item>
                <el-form-item label="微信昵称">
                    <el-input placeholder="请输入微信昵称" v-model="race_rank_form.user_name"></el-input>
                </el-form-item>
                <el-form-item class="pull-right">
                    <el-button type="primary" @click="getRaceRank(1)">查询</el-button>
                    <el-button @click="raceBack">返回</el-button>
                </el-form-item>
            </el-form>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="rank_table">
                <el-table-column prop="user_place" label="排名"></el-table-column>
                <el-table-column label="投票数">
                    <template slot-scope="scope">
                        <el-input v-show="race_rank_form.status == '1'" placeholder="请输入正整数" v-model="rank_table[scope.$index].user_votes" class="race-table-input" @blur="raceRankQuantity(scope.row)"></el-input>
                        <span v-show="race_rank_form.status == '2'">{{rank_table[scope.$index].user_votes}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="user_name" label="微信昵称"></el-table-column>
                <el-table-column label="微信头像">
                    <template slot-scope="scope">
                        <img :src="scope.row.user_img" class="race-rank-img">
                    </template>
                </el-table-column>
                <el-table-column prop="mobile" label="手机号"></el-table-column>
                <el-table-column prop="reward_info_str" label="奖品"></el-table-column>
            </el-table>
            <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :page-size="GLOBAL.PAGESIZE"
                :current-page.sync="rank_page"
                :total="rank_total"
                @current-change="getRaceRank">
            </el-pagination>
        </div>
        <div class="race-edit" v-show="showEdit">
            <h2>{{race_edit_tit}}</h2>
            <el-form :model="race_edit_form" label-width="130px">
                <el-form-item label="门店">
                    <el-select v-model="race_edit_form.shop_id" filterable @change="getRaceType(this.race_edit_form.shop_id, '2')">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="赛事类型">
                    <el-select v-model="race_edit_form.type" filterable placeholder="请选择赛事类型">
                        <el-option v-for="item in race_type_edit" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="赛事名称">
                    <el-input placeholder="请输入赛事名称" v-model="race_edit_form.name"></el-input>
                </el-form-item>
                <el-form-item label="赛事时间段" class="race-usedate-wrap">
                    <div ref="race_usedate_main">
                        <el-input v-model="race_usedate_txt" class="el-ellipsis" placeholder="请选择赛事时间段"></el-input>
                    </div>
                </el-form-item>
                <el-form-item label="赛事海报">
                    <img :src="race_edit_form.img" id="racePosterImg">
                </el-form-item>
                <el-form-item label="赛事说明">
                    <el-input
                        type="textarea"
                        :rows="3"
                        placeholder="请输入赛事说明"
                        v-model="race_edit_form.desc"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    v-for="(item, index) in race_edit_form.goods"
                    :key="index"
                    :label="item.prize + '等奖'"
                >
                    <el-row class="race-edit-row">
                        <label class="el-form-item__label">奖品名称</label>
                        <el-input placeholder="请输入奖品名称" class="race-input-normal" v-model="item.name"></el-input>
                    </el-row>
                    <el-row>
                        <label class="el-form-item__label">奖品图片</label>
                        <img :src="item.img" :id="item.img_id">
                        <el-button type="primary" @click="racePrizesAdd(index)">添加奖品券</el-button>
                    </el-row>
                    <el-table
                        :data="item.infos">
                        <el-table-column prop="gift_name" label="活动券名称"></el-table-column>
                        <el-table-column prop="gift_type_name" label="活动券类型"></el-table-column>
                        <el-table-column label="活动券数量">
                            <template slot-scope="scope">
                                <el-input placeholder="请输入正整数" v-model="item.infos[scope.$index].quantity" class="race-table-input" @blur="raceCouponQuantity($event, index, scope.$index, scope.row.quantity)"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <span class="text-blue" @click="racePrizesDel(index, scope.$index)">删除</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>
                <el-form-item>
                    <el-button @click="raceBack">返回</el-button>
                    <el-button type="primary" @click="raceEdit">确定</el-button>
                </el-form-item>
            </el-form>
        </div>
        <!-- 添加奖品 -->
        <div class="select-goods-wrap" ref="race_coupon_alert">
            <el-row :gutter="20">
                <el-col :span="8">
                    <el-select v-model="coupon_type" clearable filterable placeholder="请选择类型" @change="couponTypeChange">
                        <el-option label="优惠券" value="1"></el-option>
                        <el-option label="商品券" value="2"></el-option>
                        <el-option label="商品套餐券" value="3"></el-option>
                        <el-option label="开房套餐券" value="4"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="10">
                    <el-input placeholder="请输入活动券名称" v-model="coupon_name"></el-input>
                </el-col>
                <el-col :span="6">
                    <el-button class="pull-right" type="primary" @click="getCouponTable(1)">查询</el-button>
                </el-col>
            </el-row>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                ref="coupon_table"
                :data="coupon_table"
                @selection-change="getCouponSelect">
                <el-table-column type="selection"></el-table-column>
                <el-table-column prop="type_name" label="类型"></el-table-column>
                <el-table-column prop="name" label="名称"></el-table-column>
            </el-table>
            <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :page-size="GLOBAL.PAGESIZEMINI"
                :current-page.sync="coupon_page"
                :total="coupon_total"
                @current-change="getCouponTable">
            </el-pagination>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                showList: true,
                showEdit: false,
                showRank: false,
                loading: false,
                shop_list: [],
                race_type_list: [],
                race_type_edit: [],

                race_list_form: {
                    shop_id: '',
                    type: '',
                    name: '',
                    status: ''
                },
                race_page: 1,
				race_total: 0,
                race_table: [],

                race_rank_form: {
                    id: '',
                    type: '',
                    name: '',
                    user_name: '',
                    status: ''
                },
                rank_page: 1,
				rank_total: 0,
                rank_table: [],

                race_edit_id: '',
                race_edit_tit: '',
                race_edit_form: {
                    shop_id: '',
                    type: '',
                    name: '',
                    img: require('../../assets/images/upload_btn.png'),
                    img_done: false,
                    desc: '',
                    goods: [{
                        prize: '1',
                        name: '',
                        img: require('../../assets/images/upload_btn.png'),
                        img_id: 'raceImg0',
                        img_done: false,
                        infos: []
                    }, {
                        prize: '2',
                        name: '',
                        img: require('../../assets/images/upload_btn.png'),
                        img_id: 'raceImg1',
                        img_done: false,
                        infos: []
                    }, {
                        prize: '3',
                        name: '',
                        img: require('../../assets/images/upload_btn.png'),
                        img_id: 'raceImg2',
                        img_done: false,
                        infos: []
                    }]
                },
                race_usedate_txt: '',
				race_usedate_start: '',
                race_usedate_end: '',
                coupon_type: '',
				coupon_name: '',
				coupon_page: 1,
				coupon_total: 0,
                coupon_table: [],
                coupon_table_select: [],
            }
		},
        mounted: function() {
            new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                this.race_list_form.shop_id = this.shop_list[0].id
                this.race_list_form.type = ''
                this.race_list_form.name = ''
                this.race_list_form.status = ''
                this.getRaceTable(1)
                this.getRaceType(this.race_list_form.shop_id, '1')
                this.initDate()
                this.raceImgUpload('racePosterImg')
                this.raceImgUpload('raceImg0', 0)
                this.raceImgUpload('raceImg1', 1)
                this.raceImgUpload('raceImg2', 2)
            })
        },
        methods: {
            // 获取门店数据
			getShop: function(resolve) {
				const _this = this;

				Vue.axios.post('PublicData/api_getShopListByPurview', {
					"header": Vue.request_header,
					"request": {
						"param": {}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						_this.shop_list = res.data.response.result;
                        _this.shop_list.shift();
                        resolve()
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
                    console.log(err);
					layer.msg('出错啦');
				});
            },
            // 获取赛事类型
			getRaceType(shop_id, type) {
				const _this = this;

				Vue.axios.post('BistroMatch/getMatchTypeSearchList', {
					"header": Vue.request_header,
					"request": {
						"param": {
                            "shop_id": shop_id,
                        }
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
                        if(type == '1') {
                            _this.race_type_list = res.data.response.result;
                        } else {
                            _this.race_type_edit = res.data.response.result;
                        }
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },
            // 日期
			initDate: function() {
                const _this = this;

                $(_this.$refs.race_usedate_main).daterangepicker({
                    parentEl: '.race-usedate-wrap',
                    // drops: 'up',
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                }, function(start, end, label) {
                    event.preventDefault()
                    _this.race_usedate_start = start.format('YYYY-MM-DD HH:mm');
                    _this.race_usedate_end = end.format('YYYY-MM-DD HH:mm');
                    _this.race_usedate_txt = _this.race_usedate_start + ' ~ ' + _this.race_usedate_end;
                });
			},



            // 列表
			getRaceTable: function(page) {
				const _this = this;

				_this.loading = true;
				Vue.axios.post('BistroMatch/getMatchList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "shop_id": _this.race_list_form.shop_id,
                            "type": _this.race_list_form.type,
                            "name": _this.race_list_form.name,
                            "status": _this.race_list_form.status
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
                            _this.race_total = Number(res.data.response.result.count)
                            _this.race_page = 1
						}
						_this.race_table = res.data.response.result.data;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },
            // 删除
			raceDel(row) {
				const _this = this;

				layer.confirm('删除后不可恢复，确定删除吗？', {
					btn: ['确定', '取消']
				}, function() {
					Vue.axios.post('BistroMatch/delMatch', {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
                                "id": row.id,
                                "shop_id": row.shop_id
							}
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							layer.msg('删除成功');
							_this.getRaceTable(_this.race_page);
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this);
							layer.msg(res.data.response.error_msg);
						}
					})
					.catch(err => {
						layer.msg('出错啦');
					});
				});
            },
            // 排名
            raceRank(row) {
                this.race_rank_form.id = row.id
                this.race_rank_form.type = row.type
                this.race_rank_form.name = row.name
                this.race_rank_form.user_name = ''
                this.race_rank_form.status = row.status
                this.getRaceRank(1)
                this.showList = false
                this.showRank = true
            },
            getRaceRank: function(page) {
				const _this = this;

				_this.loading = true;
				Vue.axios.post('BistroMatch/getMatchRankingList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "id": _this.race_rank_form.id,
                            "type": _this.race_rank_form.type,
                            "user_name": _this.race_rank_form.user_name
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
                            _this.rank_total = Number(res.data.response.result.count)
                            _this.rank_page = 1
						}
						_this.rank_table = res.data.response.result.data;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },
            raceRankQuantity(row) {
                const _this = this

                if(!/^[1-9]\d*$/.test(row.user_votes)) {
                    layer.msg('请输入正整数')
                    _this.getRaceRank(_this.rank_page)
                } else {
                    Vue.axios.post('BistroMatch/changeUserVotes', {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
                                "user_match_relation_id": row.user_match_relation_id,
                                "match_type": row.match_type,
                                "votes": row.user_votes
							}
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							layer.msg('修改成功')
							_this.getRaceRank(_this.rank_page)
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this);
							layer.msg(res.data.response.error_msg);
						}
					})
					.catch(err => {
						layer.msg('出错啦');
					});
                }
            },
            // 点击新增
			raceAdd() {
                this.race_edit_id = ''
                this.race_edit_tit = '新增赛事'
                this.race_edit_form = {
                    shop_id: this.shop_list[0].id,
                    type: '',
                    name: '',
                    img: require('../../assets/images/upload_btn.png'),
                    img_done: false,
                    desc: '',
                    goods: [{
                        prize: '1',
                        name: '',
                        img: require('../../assets/images/upload_btn.png'),
                        img_id: 'raceImg0',
                        img_done: false,
                        infos: []
                    }, {
                        prize: '2',
                        name: '',
                        img: require('../../assets/images/upload_btn.png'),
                        img_id: 'raceImg1',
                        img_done: false,
                        infos: []
                    }, {
                        prize: '3',
                        name: '',
                        img: require('../../assets/images/upload_btn.png'),
                        img_id: 'raceImg2',
                        img_done: false,
                        infos: []
                    }]
                }
                this.getRaceType(this.race_edit_form.shop_id, '2')
                this.race_usedate_txt = ''
				this.race_usedate_start = ''
                this.race_usedate_end = ''
                this.showList = false
                this.showEdit = true
			},
			// 点击修改
			raceModify(row) {
                this.race_edit_id = row.id
                this.race_edit_tit = '修改赛事'
                this.race_edit_form = {
                    shop_id: row.shop_id,
                    type: row.type,
                    name: row.name,
                    img: row.img,
                    img_done: true,
                    desc: row.desc,
                    goods: []
                }
                this.getRaceType(this.race_edit_form.shop_id, '2')
                row.goods.forEach((item, index) => {
                    this.race_edit_form.goods.push({
                        prize: index + 1,
                        name: item.name,
                        img: item.img,
                        img_id: 'raceImg' + index,
                        img_done: true,
                        infos: item.infos
                    })
                })
				this.race_usedate_start = row.start_time
                this.race_usedate_end = row.end_time
                this.race_usedate_txt = row.start_time + '~' + row.end_time
                this.showList = false
                this.showEdit = true
            },
            // 图片
			raceImgUpload: function(id, index) {
				let _this = this;
				let host = '',
					dir = '',
					file_name = '';

				setTimeout(function() {
					// 实例化一个plupload上传对象
					let uploader = new plupload.Uploader({
						browse_button: id, // 选择文件id
						filters: {
							mime_types: [ // 文件格式限制
								{ title: "Image files", extensions: "jpg,jpeg,png,gif" }
							],
							// max_file_size: '2mb', // 文件大小限制
							// prevent_duplicates: true // 不允许选取重复文件
						},
						// resize: {
						// 	width: 527,
						// 	height: 296
						// },
						multi_selection: false, // 单选
						url: './', // OSS地址
						init: {
							// 文件上传前触发
							BeforeUpload: function(up, file) {},
							// 文件选择完毕触发
							FilesAdded: function(up, files) {
								// 获取签名
								Vue.axios.post('publicData/api_getOssSignature', {
									"header": Vue.request_header,
									"request": {
										"version": Vue.version,
										"param": {
											"file": files[0].name,
											"path": 'ticket_system'
										}
									},
									"comment": ""
								})
								.then(res => {
									if(res.data.response.result_code == "true") {
										host = res.data.response.data.host;
										dir = res.data.response.data.dir;
										file_name = res.data.response.data.file_name;
										const new_params = {
											'key': dir + file_name,
											'OSSAccessKeyId': res.data.response.data.accessid,
											'policy': res.data.response.data.policy,
											'signature': res.data.response.data.signature,
											'success_action_status': '200', // 让服务端返回200，不然，默认会返回204
										};
										up.setOption({
											'url': host,
											'multipart_params': new_params
										});

										// 上传文件
										uploader.start();
									} else {
										Vue.timeoutfun(data.response.result_status, _this);
										layer.msg(data.response.error_msg);
									}
								})
								.catch(err => {
									layer.msg("出错啦");
								});
							},
							// 文件上传成功触发
							FileUploaded: function(up, file, data) {
                                if(id == 'racePosterImg') {
                                    _this.race_edit_form.img = host + "/" + dir + file_name;
								    _this.race_edit_form.img_done = true;
                                } else {
                                    _this.race_edit_form.goods[index].img = host + "/" + dir + file_name;
                                    _this.race_edit_form.goods[index].img_done = true;
                                }
							},
							// 错误提示
							Error: function(up, err) {
								if(err.code == -600) {
									layer.msg('请选择2mb以内的文件');
								} else if (err.code == -601) {
									layer.msg('只允许上传jpg,jpeg,png,gif文件');
								} else if (err.code == -602) {
									layer.msg('这个文件已经上传过一遍了');
								} else {
									layer.msg(err.response);
								}
							}
						}
					});
					// 初始化
					uploader.init();
				}, 20);
            },
            // 添加奖品
			racePrizesAdd: function(index) {
				const _this = this;

				_this.coupon_type = ''
				_this.coupon_name = ''
				_this.coupon_page = 1
				_this.getCouponTable(1)
				layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['添加活动券', true],
                    area: ['700px', '500px'], // 宽高
                    content: $(_this.$refs.race_coupon_alert)
                }, function() {
                    // 保存活动券
                    _this.coupon_table_select.forEach(_ => {
                        let isTrue = true;
                        for(let i = 0; i < _this.race_edit_form.goods[index].infos.length; i++) {
                            if(_this.race_edit_form.goods[index].infos[i].gift_id == _.id) {
                                isTrue = false
                                return false
                            }
                        }
                        if(isTrue) {
                            _this.race_edit_form.goods[index].infos.push({
                                gift_id: _.id,
                                gift_name: _.name,
                                gift_type: _.type,
                                gift_type_name: _.type_name,
                                quantity: 1
                            })
                        }
                    })
                    layer.msg('保存成功')
                    _this.$refs.coupon_table.clearSelection();
                });
			},
			racePrizesDel(i, j) {
				this.race_edit_form.goods[i].infos.splice(j, 1)
			},
			couponTypeChange(val) {
				this.getCouponTable(1);
			},
			getCouponTable: function(page) {
				const _this = this;

				_this.loading = true;
                Vue.axios.post('MerchantGift/getListToTicket', {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZEMINI,
							"shop_id": _this.race_edit_form.shop_id,
							"type": _this.coupon_type,
							"name": _this.coupon_name
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.coupon_total = Number(res.data.response.result.total);
						}
						_this.coupon_table = res.data.response.result.rows;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},
			getCouponSelect(val) {
				this.coupon_table_select = val
            },
            raceCouponQuantity(val, i, j, quantity) {
                if(!/^[1-9]\d*$/.test(quantity)) {
                    layer.msg('请输入正整数')
                    this.race_edit_form.goods[i].infos[j].quantity = 1
                }
            },
            // 新增、修改
			raceEdit() {
                const _this = this;

                if(!_this.race_edit_form.img_done) {
                    layer.msg('请上传赛事海报')
                    return false
                }
                let isTrue = true;
                for(let i = 0; i < _this.race_edit_form.goods.length; i++) {
                    if(!_this.race_edit_form.goods[i].img_done) {
                        isTrue = false
                    }
                }
                if(!isTrue) {
                    layer.msg('请上传奖品图片')
                    return false
                }
                let data = {
                    "header": Vue.request_header,
					"request": {
						"param": {
                            "shop_id": _this.race_edit_form.shop_id,
                            "type": _this.race_edit_form.type,
                            "name": _this.race_edit_form.name,
                            "start_time": _this.race_usedate_start,
                            "end_time": _this.race_usedate_end,
                            "img": _this.race_edit_form.img,
                            "desc": _this.race_edit_form.desc,
                            "goods": _this.race_edit_form.goods
						}
					},
					"comment": ""
                };
                if(_this.race_edit_id) {
                    data.request.param.id = _this.race_edit_id;
                }
                Vue.axios({
					method: 'post',
					url: 'BistroMatch/addMatch',
					data: data
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						layer.msg('操作成功')
						_this.getRaceTable(_this.race_page)
						_this.showList = true
						_this.showEdit = false
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },
            // 返回
            raceBack() {
                this.showList = true
                this.showEdit = false
                this.showRank = false
            },
        }
    }
</script>
<style lang="less" scoped>
    .race-rank {
        .race-rank-img {
            display: block;
            width: 80px;
        }
    }
    .race-edit {
		.el-form {
            .el-select {
                width: 400px;
            }
            .el-input {
                width: 400px;
            }
            .el-textarea {
                width: 400px;
            }
            .race-usedate-wrap {
                position: relative;
            }
            .el-row {
                margin-bottom: 15px;
            }
            .race-table-input {
                width: 160px;
            }
            .race-edit-row {
                width: 500px;
                .race-input-normal {
                    width: 160px;
                }
                .race-input-mini {
                    width: 83px;
                }
                i {
                    color: #409eff;
                    font-size: 40px;
                    vertical-align: bottom;
                    cursor: pointer;
                }
            }
            img {
                float: left;
                width: 114px;
                height: 114px;
                margin: 0 15px 0 0;
                cursor: pointer;
            }
		}
    }
    .select-goods-wrap {
        display: none;
    }
</style>